export const GET_MEMBER_LOGIN_STATUS = "GET_MEMBER_LOGIN_STATUS";